import styled from "styled-components";

export const UsersItem = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 5.36rem;
  background: #ffffff;
  border-radius: 4.22206px;

  filter: drop-shadow(0px 5.62941px 11.2588px rgba(88, 94, 102, 0.08));
  margin-bottom: 0.6rem;

  z-index: ${({ index }) => 20 - index};
`;

export const UserFoto = styled.div`
  width: 6.8%;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserPlaceholder = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  //  background-color: gold;
`;

export const UsersName = styled.div`
  min-width: 160px;
  width: 22.27%;
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 0.94rem;
  color: #232323;
  align-self: center;
`;

export const UsersEmail = styled.div`
  min-width: 200px;
  width: 33.36%;
  font-family: Sora;
  font-style: normal;
  font-weight: 400;
  font-size: 0.94rem;
  color: #232323;
  align-self: center;
`;

export const UsersRank = styled.div`
  width: 16.81%;
  min-width: 110px;
  font-family: Sora;
  font-style: normal;
  font-weight: 400;
  font-size: 0.94rem;
  color: #232323;
  align-self: center;
`;

export const UsersStatus = styled.div`
  width: 15.18%;
  min-width: 100px;
  font-family: Sora;
  font-style: normal;
  font-weight: 400;
  font-size: 0.94rem;
  ${({ activeBackground }) => activeBackground}
  color: ${({ status }) => (status === "pending" ? "#212326" : "#169D65")};
  align-self: center;
`;

export const UserMais = styled.div`
  width: 5.58%;
  padding-right: 2rem;
  height: 5.36rem;
  display: flex;
  align-items: center;
`;
